export const incubationProjects = [{
    id: 1,
    title: "SAMPLE PROJECT 1",
    image: require('../../Assets/projects/temp-project.png'),
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna",
    link: "#"
},
{
    id: 2,
    title: "SAMPLE PROJECT 2",
    image: require('../../Assets/projects/temp-project.png'),
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna",
    link: "#"
},
{
    id: 3,
    title: "SAMPLE PROJECT 3",
    image: require('../../Assets/projects/temp-project.png'),
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna",
    link: "#"
}]

export const otherProjects = [{
    id: 1,
    title: "SAMPLE PROJECT 1",
    image: require('../../Assets/projects/temp-project.png'),
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna",
    link: "#"
},
{
    id: 2,
    title: "SAMPLE PROJECT 2",
    image: require('../../Assets/projects/temp-project.png'),
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna",
    link: "#"
},
{
    id: 3,
    title: "SAMPLE PROJECT 3",
    image: require('../../Assets/projects/temp-project.png'),
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna",
    link: "#"
},
]

